module.exports = __webpack_public_path__ + "assets/img/全新的UI框架.af2469ae.jpg";